// src/services/axios.base.query.ts
// RTK Query compatible baseQuery that wraps axiosInstance.
import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'
import axiosInstance from './axios.instance'

interface AxiosBaseQueryArgs {
  url: string
  method?: AxiosRequestConfig['method']
  data?: unknown
  params?: unknown
  headers?: Record<string, string>
  timeout?: number
}

interface ApiError {
  status: number
  data: unknown
}

export const axiosBaseQuery: BaseQueryFn<AxiosBaseQueryArgs, unknown, ApiError> =
  async ({ url, method = 'GET', data, params, headers, timeout }) => {
    try {
      const response = await axiosInstance({
        url,
        method,
        ...(data !== undefined ? { data } : {}),
        ...(params !== undefined ? { params } : {}),
        ...(headers !== undefined ? { headers } : {}),
        ...(timeout !== undefined ? { timeout } : {}),
      } as AxiosRequestConfig)
      return { data: response.data }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        return {
          error: {
            status: error.response?.status ?? 500,
            data: error.response?.data ?? { message: 'Network error' },
          },
        }
      }
      return {
        error: {
          status: 500,
          data: { message: 'Unknown error' },
        },
      }
    }
  }
